module.exports = __webpack_public_path__ + "static/media/repeat-event.4eb6c85f.svg";